<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'text', text: 'Seller Name', value: 'sellerName', rules: [v => !!v || 'Seller Name is required', v => !(v && v.length > 100) || 'Seller Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'number', text: 'Number Of Queens', value: 'numberOfQueens', rules: [v => (v !== null && v !== '') || 'Number Of Queens is required'], isRequired: true },
                    { type: 'checkbox', text: 'Are Queens Healthy', value: 'areQueensHealthy', rules: [v => (v !== null && v !== '') || 'Are Queens Healthy is required'], isRequired: true },
                    { type: 'file', text: 'Invoice File', value: 'invoiceFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'QueenPurchases',
                formTitle: 'Queen Purchase',
            }
        },
    };
</script>
